<div [formGroup]="form">
    <div class="row mt-2 col-4" *ngIf="mediosPago && mediosPago.length > 0">
        <ca-form-field>
            <ca-label>{{'CATALOGO.DATOS_PAGO.MEDIOS_PAGO' | translate}}</ca-label>
            <ca-select 
                [options]="mediosPago" 
                formControlName="medio-pago" 
                keyValue="descMedioPago"
                valueField="codigoMedioPago"></ca-select>
            <ca-error *ngIf="form.controls['medio-pago'].errors?.required">{{
            'ERROR.ERROR_CAMPO_REQUERIDO' | translate}}</ca-error>
        </ca-form-field>
    </div>
    <div class="mt-2 row" *ngIf="medioPagoSeleccionado === TipoMedioPago.CUENTA_BANCARIA">
        <div class="col-2">
            <ca-form-field>
                <ca-label>{{'CATALOGO.DATOS_PAGO.NUMERO_CUENTA' | translate}}</ca-label>
                <ca-select 
                    [options]="tiposCuenta" 
                    formControlName="tipo-cuenta" 
                    keyValue="descTipoCuenta"
                    valueField="codigoTipoCuenta"
                    [value]="TipoCuenta.CCC"></ca-select>
                <ca-error *ngIf="form.controls['tipo-cuenta'].errors?.required">{{
                'ERROR.ERROR_CAMPO_REQUERIDO' | translate}}</ca-error>
            </ca-form-field>
        </div>
        <div class="row col-9" *ngIf="tipoCuentaSeleccionada === TipoCuenta.CCC">
            <div class="col-3">
                <ca-form-field>
                    <ca-label>{{'CATALOGO.DATOS_PAGO.ENTIDAD' | translate}}</ca-label>
                    <input caInput 
                        maxlength="4" 
                        formControlName="datos-pago-entidad" 
                        placeholder="{{'CATALOGO.DATOS_PAGO.ENTIDAD' | translate}}" 
                        type="text" 
                        onlyDigits/>
                    <ca-error *ngIf="form.controls['datos-pago-entidad'].errors?.required">{{
                    'ERROR.ERROR_CAMPO_REQUERIDO' | translate}}</ca-error>
                </ca-form-field>
            </div>
            <div class="col-3">
                <ca-form-field>
                    <ca-label>{{'CATALOGO.DATOS_PAGO.SUCURSAL' | translate}}</ca-label>
                    <input caInput 
                        maxlength="4" 
                        formControlName="datos-pago-sucursal" 
                        placeholder="{{'CATALOGO.DATOS_PAGO.SUCURSAL' | translate}}" 
                        type="text" 
                        onlyDigits/>
                    <ca-error *ngIf="form.controls['datos-pago-sucursal'].errors?.required">{{
                    'ERROR.ERROR_CAMPO_REQUERIDO' | translate}}</ca-error>
                </ca-form-field>
            </div>
            <div class="col-2">
                <ca-form-field>
                    <ca-label>{{'CATALOGO.DATOS_PAGO.DC' | translate}}</ca-label>
                    <input caInput 
                        maxlength="2" 
                        formControlName="datos-pago-dc" 
                        placeholder="{{'CATALOGO.DATOS_PAGO.DC' | translate}}" 
                        type="text" 
                        onlyDigits/>
                    <ca-error *ngIf="form.controls['datos-pago-dc'].errors?.required">{{
                    'ERROR.ERROR_CAMPO_REQUERIDO' | translate}}</ca-error>
                </ca-form-field>
            </div>
            <div class="col-4">
                <ca-form-field>
                    <ca-label>{{'CATALOGO.DATOS_PAGO.CUENTA' | translate}}</ca-label>
                    <input caInput 
                        maxlength="10" 
                        formControlName="datos-pago-cuenta" 
                        placeholder="{{'CATALOGO.DATOS_PAGO.CUENTA' | translate}}" 
                        type="text" 
                        onlyDigits/>
                    <ca-error *ngIf="form.controls['datos-pago-cuenta'].errors?.required">{{
                    'ERROR.ERROR_CAMPO_REQUERIDO' | translate}}</ca-error>
                </ca-form-field>
            </div>
        </div>            
        <div class="row col-9" *ngIf="tipoCuentaSeleccionada === TipoCuenta.IBAN">
            <div class="col-9">
                <ca-form-field>
                    <ca-label>{{'CATALOGO.DATOS_PAGO.TIPO_CUENTA.IBAN' | translate}}</ca-label>
                    <input caInput 
                        maxlength="26"  
                        formControlName="datos-pago-IBAN" 
                        placeholder="{{'CATALOGO.DATOS_PAGO.TIPO_CUENTA.IBAN' | translate}}" 
                        type="text" 
                        onlyDigits/>
                    <ca-hint>{{'CATALOGO.DATOS_PAGO.TIPO_CUENTA.IBAN_HINT' | translate}}</ca-hint>
                    <ca-error *ngIf="form.controls['datos-pago-IBAN'].errors?.required">{{
                    'ERROR.ERROR_CAMPO_REQUERIDO' | translate}}</ca-error>
                    <ca-error *ngIf="form.controls['datos-pago-IBAN'].errors?.invalidIban">{{
                    'ERROR.ERROR_VALOR_INVALIDO' | translate}}</ca-error>
                </ca-form-field>
            </div>
        </div>
    </div>
</div>